import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup__title" }
const _hoisted_2 = ["innerHTML"]

import PopupTemplate from "@/components/popups/PopupTemplate.vue";
import { useDataStore } from "@/stores/data";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupCashbackInfo',
  setup(__props) {

const dataStore = useDataStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupTemplate, null, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(dataStore).cashbackInfo.title), 1),
      _createElementVNode("p", {
        class: "popup__description",
        innerHTML: _unref(dataStore).cashbackInfo.text
      }, null, 8, _hoisted_2)
    ]),
    _: 1
  }))
}
}

})